import { useToast } from '@/features/common/components/Toast/contexts/Provider'
import { printByType } from '@/features/print/thunks/printByType'
import { PrintEntry } from '@/features/print/types'
import { useAppDispatch } from '@/hooks/redux'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const usePrintDocument = () => {
    const dispatch = useAppDispatch()
    const { show: showToast } = useToast()
    const { t } = useTranslation()
    const [printing, setPrinting] = useState(false)
    const print = useCallback(
        async (entry: PrintEntry) => {
            setPrinting(true)

            try {
                const { successCount, failureCount } = await dispatch(printByType(entry)).unwrap()

                if (failureCount === 0) return

                showToast(
                    t('order.detail.reprintModal.result.printFailureTitle'),
                    t(
                        successCount === 0
                            ? 'order.detail.reprintModal.result.printTotalFailureMessage'
                            : 'order.detail.reprintModal.result.printPartialSuccessMessage'
                    )
                )
            } finally {
                setPrinting(false)
            }
        },
        [dispatch, showToast, t]
    )

    return { print, printing }
}
